import { Link, useNavigate } from "react-router-dom";
import { useLocalePath } from "../hooks/useLocalePath";
import { formatCurrency } from "../utils/formatCurrency";
import Button from "./button";
import Card from "./card";

export function MachinePreview({ machine, showQBtn = true, sx, className = "" }) {
  const navigate = useNavigate();
  const { localePath } = useLocalePath();
  const hasPrice = !!(machine.campaignPrice || machine.price);

  return (
    <Card
      className={`h-full overflow-hidden ${sx || ""} ${className}`.trim()}
      padding="p-0"
      border={false}
    >
      <Link
        to={localePath(`/machines/${machine.id}`)}
        data-testid={`machine-${machine.id}-preview-link`}
        className="block h-full overflow-hidden group"
      >
        <div className="relative">
          <img
            src={machine.images[0]}
            alt={machine.title}
            className="w-full h-48 object-cover sm:object-fill"
          />
          <span className="absolute right-2 bottom-2 inline-block max-w-[calc(100%-1rem)] truncate rounded-full border border-border-subtle bg-surface px-3 py-1 text-xs font-semibold leading-none text-text-strong shadow-sm">
            {machine.category}
          </span>
        </div>

        <div className="p-4">
          <h3 className="text-xl text-text-body font-bold transition-colors group-hover:text-primary line-clamp-2 h-14 mb-2">
            {machine.title}
          </h3>

          <div className="mb-3 min-h-[3.5rem]">
            {hasPrice &&
              (machine.campaignPrice ? (
                <div className="flex flex-col">
                  <span className="text-lg font-semibold text-error">
                    {formatCurrency(machine.campaignPrice, machine.currency || "SEK")}
                  </span>
                  {machine.price ? (
                    <div className="text-xs text-text-body">
                      <span className="line-through mr-2">
                        {formatCurrency(machine.price, machine.currency || "SEK")}
                      </span>
                      <span className="text-success-strong font-semibold">
                        Spara{" "}
                        {formatCurrency(
                          (machine.price || 0) - (machine.campaignPrice || 0),
                          machine.currency || "SEK"
                        )}
                      </span>
                    </div>
                  ) : null}
                </div>
              ) : (
                <span className="text-lg font-semibold text-primary">
                  {formatCurrency(machine.price, machine.currency || "SEK")}
                </span>
              ))}
            {!hasPrice && (
              <div className="text-sm text-text-body">
                <p className="font-semibold">Pris på förfrågan</p>
                {showQBtn && <p className="text-xs text-text-muted">Begär offert för pris.</p>}
              </div>
            )}
          </div>

          {showQBtn && (
            <Button
              sx="block w-full flex items-center justify-center gap-2 py-2"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigate(localePath(`/machines/${machine.id}/quotation`));
              }}
            >
              <span className="whitespace-nowrap">Begär offert</span>
            </Button>
          )}
        </div>
      </Link>
    </Card>
  );
}
